import axios from 'axios';

import ddProductCard from './product-card/dd-product-card.vue';

export default {
  name: 'ddabbCollectionGrid',
  components: {
    //ddProductCard: ddProductCard
  },
  props: ['collectionId'],
  data() {
    return {
      showMore: false,
      showMoreTwo: false,
      products: [],
    };
  },
  computed: {},
  methods: {
    // if tag exists
    tagExists(needle, haystack) {
      if (haystack.includes(needle)) {
        return true;
      }
      return false;
    },

    // Group the Products
    productsGroup(theGroup) {
      //return this.products.filter(product => product.group == theGroup)
      //console.log(this.products);
      return this.products.filter((product) => product.tags.includes(theGroup));
    },

    //get the products
    getCollection() {
      let targetdomain = window.location.hostname.includes(
        'development.cotopaxi.com'
      )
        ? 'https://development-access-api.cotopaxi.com'
        : 'https://production-access-api.cotopaxi.com';

      axios
        // if visiblity param is provided, call the API with that attached.
        //.get(targetdomain + `/collection/getChoiceCollectionAndProductsByCollectionId/268005867581`)
        .get(
          targetdomain +
            `/collection/getChoiceCollectionAndProductsByCollectionId/${this.collectionId}`
        )
        .then((response) => {
          this.products = response.data.products;
        })
        .catch((error) => {
          console.log(error);
          window.location.replace(
            window.location.href + '?view=default'
          );
        });
    },
    // format price
    formatPrice(price) {
      let currency = '$';
      //let formattedPrice = (price/100).toString(); // will return a whole number if no decimal is present.
      if (price.includes('.')) {
        // if we have decimal data, make sure it is 2 decimal places deep (for sezzle widget)
        price = parseFloat(price).toFixed(2).toString();
        price = price.replace('.00', '');
        // let strippedPrice = price.substr(price.length - 3)
        // if (strippedPrice === '.00'){
        // 	price
        // }
      }
      //added the turnary operator at the end for an EU legal requirement. #excludes adding this extra text to gift-cards 10/12/2020
      return `${currency}${price}`;
    },
  },
  //beforeMount() {},
  mounted() {
    this.getCollection();
    //alert('mounted');

    window.addEventListener('load', function () {
      if (document.getElementById('ddabaTab1')) {
        var thisTab = document.getElementById('ddabaTab1');

        var tabs = thisTab.getElementsByClassName('ctpx-tab');
        var tabNav = thisTab.getElementsByClassName('ctpx-tab-nav');

        //if the window is small
        if (window.innerWidth > 768) {
          //console.log('window big');

          // if there is more than 1 tab
          if (tabs.length > 1) {
            // Tabs
            const tabSystem = {
              init() {
                // Each Tab Nav Item
                thisTab.querySelectorAll('.tab-nav').forEach((tabMenu) => {
                  Array.from(tabMenu.children).forEach((child, ind) => {
                    child.addEventListener('click', () => {
                      tabSystem.toggle(child.dataset.target);
                    });
                    if (child.className.includes('active')) {
                      tabSystem.toggle(child.dataset.target);
                    }
                  });
                });
              },
              toggle(targetId) {
                // Each Tab Content Block
                thisTab
                  .querySelectorAll('.ctpx-tab')
                  .forEach((contentElement) => {
                    contentElement.style.display =
                      contentElement.id === targetId ? 'block' : 'none';
                    thisTab
                      .querySelector(`[data-target="${contentElement.id}"]`)
                      .classList[
                        contentElement.id === targetId ? 'add' : 'remove'
                      ]('active');
                  });
              },
            };
            // use it
            tabSystem.init();
          }
        }
      }
    });
  },
};
